import Sniffer from 'snifferjs';

// store
import { app } from '../utils/store';

// import Scroll from '../modules/scroll/scroll';
// import ProgressiveImageLoading from '../modules/progressiveimgs/progressiveimgs';
import Header from '../modules/header/header';
import Carousel from '../modules/carousel/carousel';
import Hero from '../modules/hero/hero';
import Cover from '../modules/cover/cover';
import Title from '../modules/title/title';
import Video from '../modules/video/video';
import Tease from '../modules/tease/tease';
import ParallaxNav from '../modules/parallax-nav/parallax-nav';
import Collage from '../modules/collage/collage';
import Gallery from '../modules/gallery/gallery';
import Lamps from '../modules/lamps/lamps';
import NextProject from '../modules/nextproject/nextproject';
import Filters from '../modules/filters/filters';
import Footer from '../modules/footer/footer';

export default class Components {
    constructor() {
        this.header = document.querySelector('header');
        this.menu = document.getElementById('main-menu');
        this.footer = document.querySelector('footer');
        this.hero = document.getElementById('hero');
        this.intro = document.getElementById('intro');
        this.cover = document.getElementById('cover');
        this.parallaxnav = document.getElementById('parallax-nav');
        this.video = document.querySelector('video');
        this.collage = document.getElementById('collage');
        this.gallery = document.getElementById('gallery');
        this.tease = document.querySelector('.tease');
        this.nextproject = document.getElementById('next-project');
        this.switcher = document.getElementById('darkmode');
        this.carousel = document.querySelector('.carousel');
        this.lamps = document.querySelector('.lamps');

        this.filters = document.getElementById('filters');

        this.page = {
            case: document.querySelector('.page-casestudies'),
        }

        this.post = {
            case: document.querySelector('.page-casestudy-article'),
            portfolio: document.querySelector('.page-portfolio-article'),
        }
    }

    init(){
        // app.scroll = new Scroll();
        // app.scroll.init();

        // Progressive Loading Image (Need 'data-src' or 'data-background' attribute)
        // app.scroll.progressiveimgs();

        // if(this.header){
        //     this.header = new Header();
        //     this.header.init();
        // }

        // if(this.hero){
        //     this.hero = new Hero();
        //     this.hero.init();
        // }

        if(this.footer){
            this.footer = new Footer();
            this.footer.init();
        }

        // if(this.filters){
        //     this.filters = new Filters();
        //     this.filters.init();
        // }

        if(this.carousel){
            this.carousel = new Carousel();
            this.carousel.init();
        }

        // if(this.intro) {
        //     this.intro = new Intro();
        //     this.intro.init();
        // }

        if(this.parallaxnav){
            this.parallaxnav = new ParallaxNav();
            this.parallaxnav.init();
        }

        if(this.collage){
            this.collage = new Collage();
            this.collage.init();
        }

        if(this.video){
            this.video = new Video();
            this.video.init();
        }

        if(this.lamps){
            this.lamps = new Lamps();
            this.lamps.init();
        }

        if((this.post.case || this.post.portfolio) && this.cover){
            this.cover = new Cover();
            this.cover.init();
        }

        if((this.post.case || this.post.portfolio) && this.gallery){
            this.gallery = new Gallery();
            this.gallery.init();
        }

        if((this.post.case || this.post.portfolio) && this.nextproject){
            this.nextproject = new NextProject();
            this.nextproject.init();
        }

        if(this.page.case){
            this.title = new Title();
            this.title.init();
        }

        if(this.page.case && this.tease){
            this.tease = new Tease();
            this.tease.init();
        }

        // this.animation = new Animation();
        // this.animation.init();
    }

    destroy = () => {
        console.log('Destroy Components')
        // if (this.intro) { this.intro = undefined }
        // if(this.menu) { this.header.destroy() };
        // if(this.switcher) { this.switcher.destroy() };
    }
}
